import { NavContent } from "./NavContent.js";
import TableView from "./components/TableView.tsx";
import InvoiceCreate from "../invoice-management/InvoiceCreate.tsx";

const BASE_PATH = "/leadManagement";
const NEW_INVOICE_PATH = "/leadManagement/new-invoice";

export const leadManagement = () => {
  return [
    {
      target: "$ONE_LAYOUT_NAV_CONTENT",
      handler: {
        component: NavContent,
        props: {
          basePath: BASE_PATH,
        },
      },
    },
    {
      target: "$ONE_LAYOUT_ROUTE",
      handler: {
        exact: true,
        path: BASE_PATH,
        element: <TableView basePath={BASE_PATH} />,
      },
    },
    {
      target: "$ONE_LAYOUT_ROUTE",
      handler: {
        exact: true,
        path: NEW_INVOICE_PATH,
        element: <InvoiceCreate basePath={NEW_INVOICE_PATH} />,
      },
    },
  ];
};
